import { useState, useEffect } from 'react';

/**
 * Returns a `Date` that ticks every `intervalMs` milliseconds.
 * Useful for live SLA countdown timers.
 */
export function useTick(intervalMs: number = 1000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
